import { DonationCheckboxContainer, DonationCheckboxLabel } from './DonationCheckbox.styles';

interface DonationTextFieldProps {
  htmlFor: string,
  labelText: string,
  onChangeMethod: (target: HTMLInputElement) => void
}

function DonationCheckbox(props: DonationTextFieldProps) {
  const {htmlFor, labelText, onChangeMethod} = props;

  return (
    <DonationCheckboxContainer>
        <input type="checkbox" id={htmlFor} name={htmlFor} onChange={(e) => onChangeMethod(e.target)}/>
        <DonationCheckboxLabel htmlFor={htmlFor}>{labelText}</DonationCheckboxLabel>
    </DonationCheckboxContainer>
  )
}

export default DonationCheckbox;